import React from 'react';

export const HashPrefixContext = React.createContext({
  hashPrefix: '',
});

export const HashPrefixConsumer = HashPrefixContext.Consumer;

export const HashPrefixProvider = ({ hashPrefix, children }) => {
  return (
    <HashPrefixContext.Provider value={{ hashPrefix }}>
      {children}
    </HashPrefixContext.Provider>
  );
};

export const withHashPrefix = (Component) => {
  return function WithHashPrefix(props) {
    const wrappedComponentName =
      Component.displayName || Component.name || 'UnknownComponent';
    Component.displayName = wrappedComponentName;
    WithHashPrefix.displayName = `WithHashPrefix(${wrappedComponentName})`;
    return (
      <HashPrefixConsumer>
        {({ hashPrefix }) => {
          return <Component hashPrefix={hashPrefix} {...props} />;
        }}
      </HashPrefixConsumer>
    );
  };
};
